import { 
    attendance_attendance_create,
    attendance_checkin_create,
    attendance_dateuser_get,
    attendance_checkout_update,
    attendance_user_get,
    attendance_date_get,
    attendance_attendance_update
} from '../Models/attendance';

//======= ATTENDANCE CREATE =========
//=========== IN ==========
export const createAttendance = (data) => {
    return new Promise((resolve, reject) => {
        attendance_attendance_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//20210817 Check In Attendance
export const checkInAttendance = (data) => {
    return new Promise((resolve, reject) => {
        attendance_checkin_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data })
        }).
        catch((error) => {
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//20210817 Check Out Attendance
export const checkOutAttendance = (data) => {
    return new Promise((resolve, reject) => {
        attendance_checkout_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data })
        }).
        catch((error) => {
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== GET ATTENDANCE BY USER ========
export const onGetAttendancelistbyuser = (data) => {
    return new Promise((resolve, reject) => {
        attendance_user_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data, branchnow: val.branchnow, ipnow : val.ipnow,holidays : val.holidays })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== USED FOR CHECK USER IN ATTENDANCE ONCE CLICK IN BUTTON =====
export const CheckAttendanceTime = (data) => {
    return new Promise((resolve, reject) => {
        attendance_dateuser_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======= MANAGEMENT ==========
export const onGetAttendancelist = (data) => {
    return new Promise((resolve, reject) => {
        attendance_date_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data, holidays: val.holidays })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== UPDATE =======
export const updateAttendance = (data) => {
    return new Promise((resolve, reject) => {
        attendance_attendance_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status , msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}
